import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppStateSelector} from "@nosto/preact";
import { productImagePlaceholder } from "../helpers";
import SubmitButton from "./elements/SubmitButton";
import Loader from "./elements/Loader"
import { useEffect } from "preact/hooks";

export default function Autocomplete() {
  const { products, keywords } = useResponse();
  const { loading } = useAppStateSelector(state => ({ loading: state.loading }))
  const { format } = useCurrencyFormatting();
  const searchQuery = useAppStateSelector(state => state.query );

  const handleSubmit = (event) => {
    event?.preventDefault?.();
    const q = searchQuery?.query?.trim();
    if (!q) return;
  
    const baseUrl = '/pages/search-results-page';
    const url = `${baseUrl}?q=${encodeURIComponent(q)}`;
    window.location.href = url.toString();
  };
  const handleDefault = (event) => {
    event?.preventDefault?.();
  };

  if (!products?.hits?.length && !keywords?.hits?.length) {
    useEffect(() => {
      setTimeout(() => {
        nostojs(api => api.createRecommendationRequest().setElements(["nosto-no-results"]).load());
      }, 1500)
    }, [products]);

    return (
      <div
        class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box"
        data-nosto-element="autocomplete"
      >
        <div class="nosto_element ns-w-100" id="nosto-no-results">
            <div class="main-search__results"><div class="main-search__empty-message">Sorry, we couldn't find any results</div></div></div>
      </div>
    );
  }



  return (
    <div
      class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box"
      data-nosto-element="autocomplete"
    >
      <div class="ns-w-100 ns-mt-sm-auto">
        <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
          <div class="ns-autocomplete-keywords ns-d-flex ns-flex-column">
            <div class="ns-autocomplete-header">Popular Suggestions</div>
            {keywords?.hits?.length > 0 && (
              <div class="ns-d-flex ns-flex-column">
                <Keywords hits={keywords.hits} keywordComponent={Keyword} elementComponent={Element} keywordInCategoryComponent={KeywordInCategory} />
              </div>
            )}
            <div class="ns-d-none ns-d-md-block">
              <SubmitButton text="View all results" onClick={handleSubmit}/>
            </div>
          </div>
          {loading && <Loader />}
          {products?.hits?.length > 0 && (
            <div class="ns-autocomplete-products ns-d-flex ns-flex-column">
              <div class="ns-autocomplete-header">Products</div>
              <div class="ns-d-flex ns-autcomplete-products-inner">
                {products?.hits?.map(hit => {
                  return (
                    <AutocompleteElement class="ns-autocomplete-product" key={hit.productId} hit={hit} url={`${hit.url}${hit.skus?.[0]?.id ? `?variant=${hit.skus[0].id}` : ''}`}>
                      <div data-url={`${hit.url}${hit.skus?.[0]?.id ? `?variant=${hit.skus[0].id}` : ''}`} class="ns-clickable ns-inner" data-nosto-element="product">
                        <div class="img-wrap">
                          <a href={`${hit.url}${hit.skus?.[0]?.id ? `?variant=${hit.skus[0].id}` : ''}`} onClick={handleDefault}>
                            <img class="ns-h-auto ns-object-contain" src={hit.skus?.[0]?.imageUrl || hit.imageUrl || productImagePlaceholder} alt={hit.name} />
                          </a>
                        </div>
                        <div>
                          <a href={`${hit.url}${hit.skus?.[0]?.id ? `?variant=${hit.skus[0].id}` : ''}`} onClick={handleDefault}>
                            <div class="ns-title">{hit.name}</div>
                            <div class="ns-description">{hit.description}</div>
                            <div class="ns-price-wrapper">
                              <span>{format(hit.skus?.[0]?.price ?? hit.price)}</span>
                              {((hit.skus?.[0]?.listPrice ?? hit.listPrice) > (hit.skus?.[0]?.price ?? hit.price)) && (
                                <span className="ns-text-striked">
                                  {format(hit.skus?.[0]?.listPrice ?? hit.listPrice)}
                                </span>
                              )}
                            </div>
                          </a>
                        </div>
                      </div>
                    </AutocompleteElement>
                  );
                })}
              </div>
            </div>
          )}
          <div class="ns-d-md-none">
            <SubmitButton text="View all results" onClick={handleSubmit}/>
          </div>
        </div>
      </div>
    </div>
  );
}

function Keyword({ hit }) {
  return (
    <span data-nosto-element="keyword">
      {hit?._highlight?.keyword ? (
        <span
          dangerouslySetInnerHTML={{
            __html: hit._highlight.keyword
          }}
        ></span>
      ) : (
        hit.keyword
      )}
    </span>
  );
}

function Element({ hit, keywordComponent, filter }) {
  return (
    <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-keyword">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.6 3.75C6.76295 3.75 3.75 6.77915 3.75 10.5409C3.75 14.3001 6.76045 17.3318 10.5 17.3318C11.9854 17.3318 13.3777 16.8561 14.5821 15.9089L18.6227 19.975C18.7663 20.1195 19.0288 20.25 19.3 20.25C19.5712 20.25 19.8337 20.1195 19.9773 19.975C20.1209 19.8305 20.25 19.567 20.25 19.2956C20.25 19.185 20.2027 19.0662 20.1614 18.9831C20.1162 18.8922 20.052 18.792 19.9773 18.7169L15.9348 14.6489C16.8771 13.4366 17.35 12.0355 17.35 10.5409C17.35 6.78165 14.3395 3.75 10.6 3.75ZM5.65 10.5409C5.65 7.85986 7.83955 5.65881 10.5 5.65881C13.1605 5.65881 15.35 7.85986 15.35 10.5409C15.35 13.3225 13.2605 15.423 10.5 15.423C7.83955 15.423 5.65 13.2219 5.65 10.5409Z"
          fill="#333333"
        />
      </svg>
      {keywordComponent}
    </AutocompleteElement>
  );
}

function KeywordInCategory({ category, children }) {
  return (
    <span class="ns-clickable">
      {category?.value ? (
        <span>
          {children}{" "}
          <span class="ns-keyword-in-category">
            in <span>{category.value}</span>
          </span>
        </span>
      ) : (
        children
      )}
    </span>
  );
}
